import { trustSignals } from "@/mocks/stats";

export default function TrustSection() {
  return (
    <section className="py-16 md:py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <span className="inline-block bg-cta-50 text-cta-700 text-xs font-semibold uppercase tracking-wider px-3 py-1 rounded-full mb-3">
            Why Trust Us
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-slate-900 mb-4">
            Built on Trust, Driven by Expertise
          </h2>
          <p className="text-slate-600 text-base md:text-lg leading-relaxed">
            We don&apos;t just sell insurance. We build lifelong relationships through transparent advice and unwavering support.
          </p>
        </div>

        {/* Trust Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {trustSignals.map((signal, idx) => (
            <div
              key={idx}
              className="bg-white rounded-2xl p-6 md:p-8 border border-slate-100 hover:border-primary-200 hover:shadow-lg transition-all duration-300 group"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-50 text-primary-600 flex items-center justify-center mb-4 group-hover:bg-primary-600 group-hover:text-white transition-all duration-300">
                <i className={`${signal.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">
                {signal.title}
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed">
                {signal.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}